module.exports = __webpack_public_path__ + "static/sport/tag-regist.158842d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/tag-regist.png
// module id = GXAM
// module chunks = 0